import type { DashboardInfo } from '@/lib/store/api/dashboardApi'
import type { PrescriptionRenewalDestinationResponse } from '@/lib/store/api/prescriptionRenewalApi'
import { PRESCRIPTION_RENEWAL_HREF } from '@/types/enums/sku-constants'
import { prescriptionRenewalHrefFromOverview } from './prescriptionRenewalHrefFromOverview'

export function prescriptionRenewalHrefFromDestination(
    data: PrescriptionRenewalDestinationResponse | undefined,
): string | undefined {
    if (data?.next_step_id) return `/prescriptions/renew/${data.next_step_id}`
    if (data?.has_gm_prescribed_medications) return `/prescriptions/renew`
    return undefined
}

/**
 * Dashboard Renew meds href: destination next step, else overview next step,
 * else the public storefront renewal page (`fallbackHref`, defaulting to GM 200007).
 */
export function prescriptionRenewalDashboardHref(
    destination: PrescriptionRenewalDestinationResponse | undefined,
    overview: DashboardInfo | undefined,
    fallbackHref: string = PRESCRIPTION_RENEWAL_HREF,
): string {
    return (
        prescriptionRenewalHrefFromDestination(destination) ??
        prescriptionRenewalHrefFromOverview(overview) ??
        fallbackHref
    )
}
